<template>
  <div>
    <div v-for="(game, j) in compitions.competionData" :key="game.name + j">
      <v-list-item
        :id="game.name"
        :key="game.name"
        :to="{
          name: 'sportsbook-category-subCategory',
          params: { category: gameName, subCategory: game.id }
        }"
      >
        <v-list-item-content>
          <v-list-item-title style="font-size: 13px">
            {{ game.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider :key="'divider' + game.name"></v-divider>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SportbookCategory',
  props: {
    compitions: { type: [Array, Object], default: () => [], required: true },
    orientation: { type: String, default: 'horizontal' }
  },
  data() {
    return {
      model: null,
      scrollClass: 'left-main'
    }
  },
  computed: {
    gameName() {
      if (this.$route.params.category) {
        return this.$route.params.category
      }
      return 'Cricket'
    },
    eventGameData() {
      return this.$route.params.subCategory
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
